<template>
  <div class="s-point-log-item">
    <div class="s-point-log-item-info" v-if="arrangedFieldsForGrid.length > 0">
      <div
        class="s-point-log-item-field"
        v-for="(field, j) in arrangedFieldsForGrid"
        :key="j"
      >
        <template v-if="field.type === 'ntd'">
          <p class="s-text-primary">
            <span class="s-text-sm">NT$ </span>
            <span class="s-font-bold">{{ $currency(getNtdAmount(field), "") }}</span>
          </p>
        </template>
        <template v-else-if="field.type === 'primary'">
          <p class="s-point-log-item-field--point">
            <span>{{ getPrimaryAmount(field) }}</span>
          </p>
        </template>
        <template v-else-if="field.type === 'primary_amount'">
          <p class="s-point-log-item-field--point">
            <span>{{ $currency(getPrimaryAmount(field), "") }}</span>
          </p>
        </template>
        <span :class="getFieldClass(field)" v-else-if="shouldShowField(field)">
          {{ getFieldDisplayText(field) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { resolveFieldText } from "@/utils/liff/resolveFieldText";

export default {
  inject: ["$currency"],
  props: {
    log: {
      type: Object,
      required: true,
    },
    fieldSetting: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    arrangedFieldsForGrid() {
      const fields = _.get(this.fieldSetting, "list", []);
      return _.sortBy(fields, ["order", "position"]);
    },
  },
  methods: {
    getLogData(key) {
      return this.log[key] ?? "";
    },
    getFieldDisplayText(field) {
      if (field.text) {
        return resolveFieldText(field.text, (key) => this.getLogData(key));
      }
      return `${field.value || ""}${this.getLogData(field.key)}`;
    },
    getNtdAmount(field) {
      if (field.text) {
        return resolveFieldText(field.text, (key) => this.getLogData(key));
      }
      if (field.key) {
        return this.getLogData(field.key);
      }
      return "";
    },
    getPrimaryAmount(field) {
      if (field.text) {
        return resolveFieldText(field.text, (key) => this.getLogData(key));
      }
      if (field.key) {
        return this.getLogData(field.key);
      }
      return "";
    },
    shouldShowField(field) {
      if (field.text) {
        return !!this.getFieldDisplayText(field).trim();
      }
      return this.getLogData(field.key) || field.value;
    },
    getFieldClass(field) {
      if (field.type === "bold") return "s-point-log-item-field--title";
      if (field.type === "text") return "s-point-log-item-field--desc";
      if (field.type === "tag") return "s-tag s-text-gray s-text-xs";
    },
  },
};
</script>

<style scoped>
.s-point-log-item {
  display: flex;
  align-items: center;
  background-color: var(--s-white);
  box-shadow: rgb(from var(--s-primary) r g b / 0.5) 0px 2px 8px 0px;
  border-radius: 5px;
}

.s-point-log-item-info {
  padding: 1rem;
  width: 100%;
  display: grid;
  grid-template-columns: auto max-content;
  grid-gap: 4px 16px;
}

.s-point-log-item-field:nth-child(even) {
  text-align: right;
}

.s-point-log-item-field--title {
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
  color: #2c2c2e;
}

.s-point-log-item-field--desc {
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #979797;
}

.s-point-log-item-field--point {
  margin: 0;
  color: var(--s-primary);

  span {
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
  }
}
</style>
